// extracted by mini-css-extract-plugin
export default {"wrapper":"InformationEditor_wrapper__9xIs1"};